/**
 * Thin wrapper autour du NotificationsContext.
 * Garde la même interface que l'ancien hook pour ne rien casser côté consumers.
 */
import { useNotificationsContext } from "./NotificationsContext";
import type { NotificationRow } from "./notifications";

interface UseNotificationsResult {
  notifications: NotificationRow[];
  loading: boolean;
  error: string | null;
  markCaseNotificationsRead: (
    caseId: string,
    type?: NotificationRow["type"]
  ) => Promise<void>;
  markNotificationsReadByIds: (notificationIds: string[]) => Promise<void>;
}

export function useNotifications(): UseNotificationsResult {
  const {
    notifications,
    loading,
    error,
    markCaseNotificationsRead,
    markNotificationsReadByIds,
  } = useNotificationsContext();

  return {
    notifications,
    loading,
    error,
    markCaseNotificationsRead,
    markNotificationsReadByIds,
  };
}
